import getErrorEndDate from 'core/controllers/validations/endDate'
import lastDateByPeriod from 'utils/pivot/date/lastDateByPeriod'
import lastDateForBTM from 'utils/pivot/date/lastDateForBTM'
import { dateToString } from '@hc-frontend/utils'

function getValidEndDate({
  startDate,
  endDate,
  period,
  isExtendedPlan,
  isBTM,
  policies,
  dob
}) {
  if (isExtendedPlan || typeof period === 'undefined') {
    return undefined
  }

  return isBTM
    ? dateToString(
        lastDateForBTM({
          sDate: startDate,
          period,
          policies,
          dob
        })
      )
    : getErrorEndDate({
        sDate: startDate,
        endDate: endDate,
        period: period
      })
    ? dateToString(lastDateByPeriod(startDate, period))
    : endDate
}

export default getValidEndDate
